import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { IPageScrollConfig } from '@mnz-core/modules/page-scroll/models/page-scroll-config';
import { PageScrollOptions, PageScrollService as ngxPageScrollService, PageScrollTarget } from 'ngx-page-scroll-core';

@Injectable()
export class PageScrollService {
  constructor(@Inject(DOCUMENT) private readonly _document: Document, private readonly _page: ngxPageScrollService) {}

  /**
   * Scrolls to the given target.
   *
   * Example: if target is 'test', scrolls to element with id: 'test'
   * @param target The target element
   * @param config Additional configuration
   * @returns returns true when the scrolling is finnished and false if interrupted
   */
  public async scrollTo(scrollTarget: PageScrollTarget, config?: IPageScrollConfig): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      const scrollFinishListener = new EventEmitter<boolean>();
      setTimeout(async () => {
        const scrollConfig: PageScrollOptions = {
          document: this._document,
          scrollTarget,
          scrollFinishListener,
          ...config
        };

        this._page.scroll(scrollConfig);
        resolve(await scrollFinishListener.toPromise());
      }, (config && config.timeout) || 50);
    });
  }
}
